<template>
  <div>
    <div class="drawer-header px-15">
      {{order.order_no}}
      <div class="header-action">
        <Spinner  v-if="isLoading" />
        <Button v-else type="primary" size="mini"
          @click="acceptIndent">{{$t('INDENT_ACCEPT')}}</Button>
      </div>
    </div>
    <div class="drawer-body drawer-scroll pt-0">
      <div class="flex-container panel-head">
        <div class="flex-item">
          <p>
            {{$t('INDENT_ROUTE')}} :
            <strong>{{getOrderRoute}}</strong>
          </p>
          <p v-if="order.vehicle_type && order.vehicle_type.short_form">
            {{$t('INDENT_VEHICLE_TYPE')}} :
            <strong>{{ order.vehicle_type.short_form}}</strong>
          </p>
        </div>
      </div>
      <div class="clearfix mx-pd-15">
        <h5 class="header-stripe">
          <span>{{$t('INDENT_PICKUPS')}}</span>
        </h5>
        <div class="text-sm my-15" v-for="(source,index) in getSourceAddress" :key="index">
          <p><strong>{{source.name}}</strong></p>
          <p>{{$t('INDENT_ADDRESS')}}: <strong>{{getAddress(source)}}</strong></p>
        </div>
      </div>
      <div class="clearfix mx-pd-15 bg-grey-lighter">
        <h5 class="header-stripe">
          <span>{{$t('INDENT_DROPOFFS')}}</span>
        </h5>
        <div class="text-sm my-15" v-for="(drop,index) in getDrops" :key="index">
          <p><strong>{{drop.address.name}}</strong></p>
          <p>{{$t('INDENT_ADDRESS')}}: <strong>{{getAddress(drop.address)}}</strong></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { contractTypes } from '@/constants/indentConstants';
import getRoute from '@/lib/Route';
import getAddress from '@/lib/Address';
import { mapGetters } from 'vuex';

export default {
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      freightRate: '',
      contractTypes,
      getAddress,
      vehicleType: [],
      selectedVehicleType: '',
      remarks: '',
      isLoading: false,
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
    }),
    getDrops() {
      const resArr = [];
      this.order.destinations.forEach((item) => {
        const i = resArr.findIndex(x => x.location_id === item.location_id);
        if (i === -1) {
          resArr.push(item);
        }
      });
      return resArr;
    },
    getSourceAddress() {
      const resArr = [];
      const visited = [];
      this.order.sources.filter((item) => {
        let i = 0;
        let isGate = false;
        if (item.gate_id) {
          i = visited.findIndex(x => x.gate_id === item.gate_id);
          isGate = true;
        } else {
          i = visited.findIndex(x => x.location_id === item.location_id);
        }
        if (i <= -1) {
          let sourceAddress = {};
          if (isGate) {
            const gate = item.address && item.address.gates && item.address.gates
            // eslint-disable-next-line no-underscore-dangle
              .find(gateDetail => gateDetail._id === item.gate_id);
            sourceAddress = gate;
          } else {
            sourceAddress = item.address;
          }
          visited.push(item);
          resArr.push(sourceAddress);
        }
        return null;
      });
      return resArr;
    },
    getOrderRoute() {
      const item = getRoute(this.order.sources, this.order.destinations);
      return `${item.from} to ${item.tooltipText || item.to}`;
    },
  },
  methods: {
    async acceptIndent() {
      try {
        this.isLoading = true;
        const result = await this.$store.dispatch('indents/indentRepublishRequestAccept', {
          orderNo: this.order.order_no,
        });
        if (result && result.error) {
          this.$errorMessage({ message: result.error || 'Something went wrong' });
        } else {
          this.$successMessage({ message: 'Accepted Successfully' });
          this.$emit('accept');
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
